import { NgRedux } from '@angular-redux/store';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageChangeCallback, LanguageChangeService } from "../../services/language-change.service";
import { UserLoginService } from "../../services/user-login.service";
import { LoggedInCallback } from "../../services/utils/cognito.service";
import { Logger } from "../../services/utils/logger";
import { LoggingLevel } from '../../services/utils/logging-level';
import { CHANGE_LANGUAGE } from '../../services/utils/state-management/actions';
import { IAppState } from '../../services/utils/state-management/store';
import { Config } from '../../services/utils/Config';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit, LanguageChangeCallback, LoggedInCallback {

  language: string = '';
  availableLanguages: string[] = [];
  lang;
  languageMsg;
  selectedlang:string;

  constructor(
    public translate: TranslateService,
    private logger: Logger,
    public userService: UserLoginService,
    public languageService: LanguageChangeService,
    private ngRedux: NgRedux<IAppState>
  ) { }

  ngOnInit() {
    const reduxBrand = this.ngRedux.getState().userBrand || '';
    const localBrand = localStorage.getItem('userBrand') || '';
    const userBrand = (reduxBrand || localBrand).toLowerCase();
    const translatedLangs = (this.translate.getLangs() || []).map((lang: string) => this.normalizeLanguageLabel(lang));
    const brandLanguageMap: { [key: string]: string[] } = {
      kwikset: [Config.LANGUAGES['en-us'], Config.LANGUAGES.es],
      weiser: [Config.LANGUAGES['en-us'], Config.LANGUAGES.fr]
    };
    const allowedLanguages = brandLanguageMap[userBrand];
    this.availableLanguages = allowedLanguages
      ? translatedLangs.filter((lang: string) => allowedLanguages.includes(this.normalizeLanguageLabel(lang)))
      : translatedLangs;

    if (this.ngRedux.getState().preferredLanguage && this.ngRedux.getState().preferredLanguage != '') {
      this.language = this.normalizeLanguageLabel(this.ngRedux.getState().preferredLanguage);
      this.translate.use(this.language)
    }

    if (allowedLanguages && this.availableLanguages.length > 0 && !this.availableLanguages.includes(this.language)) {
      this.onLanguageChange(this.availableLanguages[0]);
    }

  }

  onLangClick(lang:string) {
    this.selectedlang = lang;
    this.onLanguageChange(this.selectedlang);
  }

  onLanguageChange(lang) {
    const selectedLanguage = this.normalizeLanguageLabel(lang);
    this.translate.use(selectedLanguage)
    this.language = selectedLanguage;
    this.ngRedux.dispatch({
      type: CHANGE_LANGUAGE,
      preferredLanguage: selectedLanguage
    });
    this.userService.isAuthenticated(this);
  }

  private normalizeLanguageLabel(lang: string): string {
    if (!lang) {
      return Config.LANGUAGES['en-us'];
    }

    const normalizedLang = lang.trim();
    const byCode = Config.LANGUAGES[normalizedLang.toLowerCase()];
    if (byCode) {
      return byCode;
    }

    const byNameCode = Config.LANGUAGES[normalizedLang.toUpperCase()];
    if (byNameCode) {
      return Config.LANGUAGES[byNameCode] || Config.LANGUAGES['en-us'];
    }

    return normalizedLang;
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    this.logger.log(LoggingLevel.INFO, "AppComponent: the user is authenticated:", isLoggedIn.toString());
    this.languageService.updateUserLanguage(isLoggedIn, this.language, this)

  }

  onSuccessSendCode() {
    location.reload();
    return;
  }

  onFailure() {
    return;
  }

}

